import React from "react";
import { Translate } from "orion-components/i18n";

const deviceStatusChangeBuilder = (rule, collections, shapes) => {
	// Determine feed names if subjects are specified
	let feedDisplay = null;
	let isMultiple = false;
	if (rule.subject && rule.subject.length > 0) {
		const feedNames = rule.subject.filter(s => s && (s.name || s.feedId)).map(s => s.name || s.feedId);
		if (feedNames.length > 0) {
			feedDisplay = feedNames.join(", ");
			isMultiple = feedNames.length > 1;
		}
	}

	const configuredPropertyOptions = rule.ruleTypeConfiguration?.options?.propertyOptions || [];

	// Determine status type from targets
	let statusPropertyLabel = "";
	let statusPropertyType = "";
	let statusType = "any";
	let statusValue = "";
	if (rule.targets && rule.targets.length > 0 && rule.targets[0]) {
		const propertyOption = configuredPropertyOptions.find(option => option.prop === rule.targets[0].statusProperty);
		statusPropertyLabel = propertyOption?.label || rule.targets[0].statusPropertyLabel || rule.targets[0].statusProperty;
		statusPropertyType = propertyOption?.type || rule.targets[0].statusPropertyType || "";
		statusType = rule.targets[0].statusType || "any";
		statusValue = rule.targets[0].statusValue ?? "";
	}

	return (
		<div id="rule-statement" className="cb-font-b9">
			<Translate value="global.ruleBuilder.deviceStatusChange.alarmMe" />
			{feedDisplay ? (
				<Translate
					value={
						isMultiple
							? "global.ruleBuilder.deviceStatusChange.fromFeeds"
							: "global.ruleBuilder.deviceStatusChange.fromFeed"
					}
					count={feedDisplay}
				/>
			) : (
				<Translate value="global.ruleBuilder.deviceStatusChange.anyDevice" />
			)}
			{statusType === "specific" && (
				<span>
					{isMultiple ? " change " : " changes "}
					{statusPropertyLabel} to {statusPropertyType === "string" ? `"${statusValue}"` : String(statusValue)}
				</span>
			)}
			{statusType === "any" && (
				<span>
					{isMultiple ? " change " : " changes "}
					{statusPropertyLabel}
				</span>
			)}
		</div>
	);
};

export default deviceStatusChangeBuilder;
